// 登录状态
export const APP_LOGIN = 'APP_LOGIN'
export const APP_LOGOUT = 'APP_LOGOUT'
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS'
export const SET_PAAS_NAME = 'SET_PAAS_NAME'
export const GET_PRIMARY_ACCOUNTS = 'GET_PRIMARY_ACCOUNTS'
export const SET_IDENTITY = 'SET_IDENTITY'
export const CHANGE_IDENTITY = 'CHANGE_IDENTITY'
export const CLS_VUEX_DATA = 'CLS_VUEX_DATA'
// 显示
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
export const GET_AUTH_DOT = 'GET_AUTH_DOT'
